import { createChildListViewContainer } from 'factories/ChildListView'
import actions from 'actions/customers/approvalTree'
import Component from 'components/Customers/FormView/ApprovalTree'

export default createChildListViewContainer({ actions })(Component)
